<template>
  <!-- Dentro il form del processo (dialog a tutto schermo) un drawer non troverebbe il layout:
       la chat sta quindi in un dialog affiancato, alto quanto la finestra. -->
  <v-dialog v-model="chat.open" width="560" persistent no-click-animation class="project-chat">
    <v-card class="project-chat__card">
      <AiChatBody :chat="chat" project />
    </v-card>
  </v-dialog>
</template>

<script setup>
import { watch } from 'vue'
import AiChatBody from './AiChatBody.vue'
import { useProjectChatStore } from '../stores/projectChat.js'

const props = defineProps({
  projectId: { type: String, default: null }
})

const chat = useProjectChatStore()

// Cambiando processo la conversazione riparte: i documenti in cache sono di un'altra cartella.
watch(() => props.projectId, (id) => {
  if (id) chat.setProject(id)
}, { immediate: true })

watch(() => chat.open, (isOpen) => {
  if (isOpen && chat.models.length === 0) chat.loadModels()
})
</script>

<style scoped>
.project-chat__card {
  display: flex;
  flex-direction: column;
  height: 85vh;
  /* La card non scorre: dentro scorre solo l'elenco dei messaggi, così la barra resta in cima. */
  min-height: 0;
  overflow: hidden;
}
</style>
